<template>
  <v-dialog
    v-model="show"
    max-width="300px"
    persistent
    :fullscreen="requiredCnh"
  >
    <v-snackbar top color="red" v-model="snackbar.show" :timeout="3500">
      {{ snackbar.text }}
    </v-snackbar>

    <v-card class="pa-4 pt-5">
      <div v-if="!requiredCnh">
        <v-btn icon @click="closeShow()" class="float">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <div v-else>
        <v-btn icon @click="closeShow()" class="floatBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
      <v-layout :class="requiredCnh ? 'hight-pt' : 'low-pt'" column>
        <div class="subheading pb-2">
          <span class="top-title pt-4"> Precisamos dos dados da sua CNH. </span>
          <div class="medium-text">Tire uma foto da sua CNH aberta</div>
        </div>

        <!-- input para android -->
        <div v-if="identifyAndroid()" class="imagem mx-auto mt-4 mb-2">
          <span>
            <img
              class="imagem pr-3"
              style="max-height: 100px"
              :src="require(`@/assets/icons/cnh-icon.png`)"
            />
          </span>
        </div>
        <!-- input default -->
        <div v-if="!identifyAndroid()" class="imagem mx-auto mt-4 mb-2">
          <img
            class="imagem"
            style="max-height: 100px"
            :src="require(`@/assets/icons/cnh-icon.png`)"
          />
          <label for="selectFile" class="selectImgIcon">
            <v-icon size="60" color="success" v-if="selectedImg"
              >done_outline</v-icon
            >
          </label>
          <input
            capture="environment"
            id="selectFile"
            type="file"
            style="display: none"
            accept="image/pdf/*"
            @change="onFileSelected"
          />
        </div>

        <!-- input CNH DIGITAL -->
        <input
          type="file"
          id="pdfFile"
          accept="application/pdf"
          @input="uploadPdfAndroid"
          width="48"
        />
        <label for="pdfFile" class="pb-3 text-center">
          <img :src="require(`@/assets/icons/anexar_cnh.png`)" alt="pdf" />
        </label>

        <div :class="requiredCnh ? 'big-text px-4' : 'big-text'">
          Algumas dicas importantes para a captura da CNH:
        </div>
        <div :class="requiredCnh ? 'subtext ml-4' : 'subtext'">
          <div>1) A CNH precisa estar aberta.</div>
          <div>2) Evite segurar o documento.</div>
          <div>3) Desligue o flash da câmera.</div>
        </div>

        <div style="margin-bottom: 10px">
          <div v-if="!requiredCnh">
            <div class="big-text pt-3">Outras informações</div>
            <div class="subtext pl-0">
              <div>1) Essa janela pode ser fechada a qualquer momento.</div>
              <div>
                2) Esse procedimento não é impeditivo para seu cadastro.
              </div>
              <div>3) A captura pode ser realizada em outro momento.</div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <v-btn
            rounded
            class="colorBtn white--text"
            width="250px"
            @click="capture()"
          >
            Capturar CNH
          </v-btn>
        </div>
      </v-layout>
    </v-card>
    <v-dialog v-model="modalFiles" width="300">
      <v-card height="290px">
        <v-btn large text @click="modalFiles = false">
          <v-icon>mdi-keyboard-backspace</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="font-weight-medium">
          Aguarde, enviando informações!
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
function cFile2Blob(cfile, cb) {
  let fr = new FileReader();
  fr.onloadend = (ev) => {
    let b = new Blob([ev.target.result], { type: 'image/jpeg' });
    b.name = cfile.name;
    cb(b);
  };
  fr.readAsArrayBuffer(cfile);
}
import CnhController from './../../controllers/CnhController';
export default {
  async created() {},

  data() {
    return {
      CnhPdf: null,
      modalFiles: false,
      rules: {
        required: (value) => !!value || 'Campo Obrigatório',
      },
      snackbar: {
        show: false,
        text: null,
      },
      selectedImg: false,
      cnhImage: '',
      cnhController: new CnhController(this.$resource),
      dialog: false,
    };
  },

  props: {
    show: Boolean,
    internal: Boolean,
    requiredCnh: Boolean,
  },

  methods: {
    closeShow() {
      this.$emit('close');
    },
    alert(text, color) {
      this.snackbar.text = text;
      this.snackbar.show = true;
    },

    identifyAndroid() {
      if (navigator.userAgent.match(/Android/i)) {
        return true;
      } else {
        return false;
      }
    },
    capture() {
      navigator.camera.getPicture(
        this.onSuccess.bind(this),
        () => {
          this.selectedImg = false;
        },
        {
          quality: 50,
          destinationType: Camera.DestinationType.FILE_URI,
        }
      );
    },
    onSuccess(imageURI) {
      this.cnhImage = imageURI;
      this.uploadAndroid();
    },

    async onFileSelected(e) {
      let image = e.target.files[0];
      // compactação inicio
      const width = 100;
      const fileName = e.target.files[0].name;
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        try {
          const elem = document.createElement('canvas');
          const scaleFactor = width / img.width;
          elem.width = width;
          elem.height = img.height * scaleFactor;
          const ctx = elem.getContext('2d');
          // img.width and img.height tem as dimensões originais
          ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
          ctx.canvas.toBlob(
            (blob) => {
              const file = new File([blob], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              image = file;
            },
            'image/jpeg',
            1
          );

          this.cnhImage = image;

          this.upload();
        } catch (error) {
          console.log(error);
        }
      };
    },
    async upload() {
      let data = new FormData();
      return new Promise(
        (resolve, reject) => {
          data.append('cnhImage', this.cnhImage);
          this.dialog = true;
          this.cnhController.uploadPhotos(data, this.internal).then(
            (res) => {
              this.selectedImg = true;
              this.alert(res.message, 'success');
              this.dialog = false;
              this.$emit('success', res.data);
            },
            (err) => {
              this.selectedImg = false;
              this.cnhImage = '';
              this.dialog = false;
              console.log(err.status);
              if (err.status == '500' || err.status == '404') {
                this.alert('Erro interno do servidor', 'error');
              } else {
                this.alert(err.bodyText, 'error');
              }
            }
          );
        },
        (error) => {
          reject(error);
        }
      );
    },
    uploadPdfAndroid(e) {
      this.cnhImage = e.target.files[0];
      this.dialog = true;
      let data = new FormData();
      data.append('cnhImage', this.cnhImage);
      return new Promise((resolve, reject) => {
        this.cnhController.uploadPhotos(data, this.internal).then(
          (res) => {
            this.selectedImg = true;
            this.alert(res.message, 'success');
            this.dialog = false;
            this.$emit('success', res.data);
          },
          (err) => {
            this.selectedImg = false;
            this.cnhImage = '';
            this.dialog = false;
            this.alert(err.bodyText, 'red');
          }
        );
      });
    },
    async uploadAndroid() {
      let data = new FormData();
      return new Promise(
        (resolve, reject) => {
          window.resolveLocalFileSystemURL(this.cnhImage, (fileEntry) => {
            fileEntry.file((cfile) => {
              cFile2Blob(cfile, (blob) => {
                data.append('cnhImage', blob);
                this.dialog = true;
                this.cnhController.uploadPhotos(data, this.internal).then(
                  (res) => {
                    this.selectedImg = true;
                    this.alert(res.message, 'success');
                    this.dialog = false;
                    this.$emit('success', res.data);
                  },
                  (err) => {
                    this.selectedImg = false;
                    this.cnhImage = '';
                    this.dialog = false;
                    this.alert(err.bodyText, 'red');
                  }
                );
              });
            });
          });
        },
        (error) => {
          console.error(error);
          reject(error);
        }
      );
    },
  },
};
</script>

<style scoped>
.col {
  padding: 0;
}
.container {
  padding-top: 0;
}
.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}

.colorSelectedBack {
  background-color: var(--secondary-color);
}

.sizeTop {
  height: 48px;
}

.vehicleMap {
  position: relative;
  height: 60vh;
}

.content {
  min-height: 100vh;
  position: relative;
}

.titleMap {
  padding-top: 70px;
}

.headline {
  padding-top: 80px;
}

.contentInside {
  min-height: 73vh;
  padding-bottom: 80px;
  position: relative;
}

.imagem {
  width: auto;
  background-color: transparent;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
}
.selectImgIcon {
  height: 100px;
  width: 100px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: 70%;
  margin-top: -50px;
}

.steps {
  padding-top: 80px;
}

.footer {
  position: fixed;
  bottom: 56px;
  width: 100%;
}

.choices {
  display: flex;
}

.colorCheckin {
  color: var(--secondary-color) !important;
}

.colorCheckinFundo {
  background-color: var(--secondary-color) !important;
}

.colorCheckoutFundo {
  background-color: var(--orange-color) !important;
}

.colorCheckout {
  color: var(--orange-color) !important;
}

.bottom {
  margin-bottom: 100px;
}

.button {
  margin: 0 auto;
}

.cardRadius {
  border-radius: 4px;
}

.colorBtn {
  background-color: var(--primary-color) !important;
}

.button-text {
  text-transform: none;
}

.radio {
  display: flex;
  justify-items: center;
  align-content: space-between;
}
.hidden {
  visibility: hidden;
}
.subtext {
  line-height: 21px;
  font-size: 14px;
  text-align: left;
  padding-left: 0;
  padding-bottom: 0;
}
.medium-text {
  font-weight: 400;
  font-size: 14px;
}
.big-text {
  line-height: 16px;
  font-weight: 700;
  font-size: 14px;
  padding-bottom: 5px;
}
#center {
  text-align: left;
  padding-left: 28px;
  line-height: 13px;
}
#pdfFile {
  display: none;
}
.check {
  color: var(--primary-color) !important;
}
.top-title {
  font-weight: 700;
  font-size: 18px;
}
.float {
  position: absolute;
  top: 10px;
  right: 10px;
  color: black !important;
}
.floatBack {
  position: absolute;
  top: 25px;
  left: 20px;
  color: var(--primary-color) !important;
}
.hight-pt {
  padding-top: 70px;
  padding-left: 20px;
}
.low-pt {
  padding-top: 20px;
}
</style>
